import { createSlice } from "@reduxjs/toolkit";

const initialDocumentsState = {
    triggerFileUpload: false,
    documentTypeId: null,
}

const documentsSlice = createSlice({
    name: 'documents',
    initialState: initialDocumentsState,
    reducers: {
        setTriggerFileUpload(state, data) {
            state.triggerFileUpload = true
            state.documentTypeId = data.payload
        },
        resetTriggerFileUpload(state) {
            state.triggerFileUpload = false
            // state.documentTypeId = null
        },
        resetDocumentTypeId(state) {
            state.documentTypeId = null
        }
    }
})

export const documentsActions = documentsSlice.actions

export default documentsSlice.reducer